Whether the logo from the provided `AdvertisementBranding` will be visible on the job ad.
